<template>
  <o-sidebar
    position="static"
    :mobile="mobile"
    :expand-on-hover="expandOnHover"
    :reduce="reduce"
    open
    class="sidebar-layout"
    contentClass="sidebar-layout-content"
  >
    <a class="homebtn" href="/">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <h1 class="h1-mobile" v-if="mq.xs || mq.sm">BN</h1>
      <h1 v-else>BlackCatNFTArt</h1>
    </a>
    <section style="margin-left: -0.5rem">
      <a class="sidebar-link" href="https://foundation.app/@black.cat">
        <svg
          :class="`${mq.xs || mq.sm ? 'mobile' : 'full'}`"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 72 72"
        >
          <path id="foundation-1" fill="#fff" d="M0 0h72v72H0z" />
          <path
            id="foundation-2"
            d="M43.164 36.005c0-2.113.005-4.226-.006-6.339-.001-.351.257-.775.76-.77.235.002.469 0 .703 0h11.943c.42 0 .698.197.792.564.014.053.018.11.018.164v12.761a.713.713 0 01-.661.715c-.04.003-.08.004-.12.004l-12.657.001c-.249 0-.46-.072-.617-.274a.713.713 0 01-.157-.451c.002-2.125.002-4.25.002-6.375zM42.17 36.012c.01 4.154-3.372 7.53-7.545 7.541-4.128.012-7.54-3.317-7.563-7.501a7.548 7.548 0 017.547-7.605c4.167-.017 7.554 3.371 7.562 7.565zM20.448 43.064H12.87c-.059 0-.12 0-.178-.009-.257-.038-.394-.297-.27-.523.143-.262.297-.517.445-.775l3.419-5.92 3.843-6.651c.15-.26.49-.263.64-.004.865 1.494 1.728 2.99 2.592 4.486l3.365 5.826c.578 1 1.156 2 1.733 3.002.156.27.002.55-.311.567-.044.002-.088 0-.131 0h-7.568z"
          />
        </svg>

        <h5 v-if="!(mq.xs || mq.sm)">Foundation</h5>
      </a>
      <a class="sidebar-link" href="https://hicetnunc.art/black.cat">
        <svg
          :class="`${mq.xs || mq.sm ? 'mobile' : 'full'}`"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0"
          y="0"
          viewBox="0 0 72 72"
          xml:space="preserve"
        >
          <path id="hen-1" d="M0 0h72v72H0z" style="fill: #f9f9f9" />
          <path
            id="hen-2"
            d="M57.38 41.74H53.6a.49.49 0 01-.08-.08.16.16 0 01-.03-.09V34.1h-3.86v7.6h-3.87V30.22h11.62v11.52zM22.38 34.02v-3.77h3.84v11.46h-3.8v-3.65a.92.92 0 00-.11-.12.17.17 0 00-.1-.04h-3.68v3.79h-3.9V30.27h3.86v3.75h3.9zM30.17 34.03v-3.77h11.64c.02 1.22 0 2.47.01 3.77H30.17zM30.2 37.92h11.58v3.72c-.88.15-8.28.2-11.59.06v-3.78z"
          />
        </svg>
        <h5 v-if="!(mq.xs || mq.sm)">Hic Et Nunc</h5>
      </a>
      <a class="sidebar-link" href="https://showtime.io/black_cat">
        <svg
          :class="`${mq.xs || mq.sm ? 'mobile' : 'full'}`"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="burlywood"
            id="showtime"
            d="M11.69.255A.318.318 0 0112 0c.15 0 .28.107.31.255A14.788 14.788 0 0023.745 11.69c.148.03.255.16.255.31s-.107.28-.255.31A14.788 14.788 0 0012.31 23.745.318.318 0 0112 24a.318.318 0 01-.31-.255A14.788 14.788 0 00.255 12.31.318.318 0 010 12c0-.15.107-.28.255-.31A14.788 14.788 0 0011.69.255z"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="24"
              y1="0"
              x2="0"
              y2="24"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FFFBEB"></stop>
              <stop offset=".234" stop-color="#FDE68A"></stop>
              <stop offset=".693" stop-color="#F59E0B"></stop>
            </linearGradient>
          </defs>
        </svg>
        <h5 v-if="!(mq.xs || mq.sm)">ShowTime</h5>
      </a>
      <a class="sidebar-link" href="https://opensea.io/black_cat_art">
        <svg
          :class="`${mq.xs || mq.sm ? 'mobile' : 'full'}`"
          viewBox="0 0 90 90"
          fill="none"
          version="1.1"
          id="svg4"
        >
          <g>
            <rect
              style="
                fill: #007d96;
                fill-opacity: 1;
                stroke: #20a9be;
                stroke-width: 1.63477;
                stroke-opacity: 1;
              "
              id="opensea-1"
              width="87.706482"
              height="87.546028"
              x="1.2318428"
              y="1.2318418"
              rx="1.7372183"
            />
          </g>
          <g style="display: inline">
            <path
              d="m 45.36027,10.813609 c -25.949657,0 -36.4888545,10.356846 -36.4888545,37.570593 0,27.213748 10.2074795,34.43971 36.1571375,34.43971 25.949657,0 35.714849,-7.805755 35.714849,-35.019503 0,-27.213748 -9.424075,-36.9908 -35.383132,-36.9908 z M 20.447781,49.112422 20.645153,48.777302 32.872788,28.71936 c 0.178575,-0.285838 0.601514,-0.256269 0.733095,0.05914 2.039506,4.800107 3.806451,10.773135 2.979371,14.48903 -0.347751,1.527754 -1.315811,3.597615 -2.406054,5.509773 -0.140979,0.275981 -0.291358,0.551963 -0.460533,0.818088 -0.07518,0.118278 -0.206771,0.187274 -0.347751,0.187274 H 20.80493 c -0.338352,0 -0.535723,-0.384404 -0.357149,-0.670242 z m 54.483941,6.899538 c 0,0.187273 -0.103384,0.344977 -0.253762,0.413973 -0.949264,0.423828 -4.191796,1.991009 -5.535802,3.952448 C 65.702254,65.395332 63.080032,72.57085 57.205879,72.57085 H 32.713012 c -8.684347,0 -15.714533,-7.402218 -15.714533,-16.539177 v -0.295694 c 0,-0.236556 0.187972,-0.433686 0.422939,-0.433686 h 13.646831 c 0.272561,0 0.469932,0.256269 0.451135,0.542107 -0.103385,0.92651 0.06579,1.882588 0.488729,2.749958 0.808284,1.724885 2.490642,2.799241 4.304579,2.799241 h 6.757626 v -5.529487 h -6.682437 c -0.338351,0 -0.545121,-0.413972 -0.347749,-0.709666 0.07518,-0.118278 0.150378,-0.236555 0.244365,-0.374546 0.629709,-0.946222 1.531978,-2.404981 2.434249,-4.070728 0.610911,-1.123638 1.203026,-2.32613 1.682357,-3.52862 0.09399,-0.216842 0.169175,-0.443542 0.253763,-0.660385 0.131581,-0.384403 0.263162,-0.749092 0.357149,-1.103925 0.09399,-0.305552 0.178574,-0.620959 0.253763,-0.916653 0.225567,-1.025074 0.319554,-2.109287 0.319554,-3.232927 0,-0.443541 -0.01879,-0.906796 -0.05639,-1.340481 -0.01879,-0.482968 -0.07518,-0.965935 -0.131581,-1.448903 -0.0376,-0.423829 -0.112785,-0.847658 -0.187974,-1.281343 -0.103384,-0.640672 -0.234966,-1.281343 -0.385344,-1.922014 l -0.05639,-0.246412 c -0.112783,-0.443541 -0.216169,-0.857514 -0.34775,-1.301056 -0.385344,-1.379907 -0.817681,-2.730246 -1.287614,-3.991875 -0.169176,-0.50268 -0.357149,-0.985648 -0.55452,-1.458759 -0.281959,-0.72938 -0.573317,-1.389765 -0.83648,-2.010723 -0.140979,-0.285838 -0.253763,-0.542107 -0.366546,-0.808232 -0.131582,-0.295694 -0.263163,-0.591388 -0.404142,-0.877226 -0.09399,-0.216843 -0.20677,-0.42383 -0.28196,-0.620958 l -0.82708,-1.596751 c -0.112784,-0.216843 0.07518,-0.482968 0.300756,-0.413972 l 5.169254,1.468616 h 0.01879 0.01879 l 0.676702,0.206986 0.751892,0.216843 0.272561,0.07886 v -3.213213 c 0,-1.557324 1.184229,-2.818954 2.659816,-2.818954 0.733095,0 1.400399,0.315408 1.87033,0.827945 0.479331,0.512537 0.780088,1.212347 0.780088,1.991009 v 4.780394 l 0.554519,0.157704 c 0.0376,0.01972 0.08459,0.03942 0.122184,0.06899 0.13158,0.09856 0.328952,0.256269 0.573317,0.453398 0.197371,0.157704 0.404141,0.354834 0.648506,0.56182 0.498128,0.423828 1.099641,0.965935 1.748148,1.586893 0.169176,0.157705 0.338352,0.315408 0.498128,0.482968 0.83648,0.818088 1.776344,1.774167 2.678614,2.838667 0.253764,0.305551 0.498128,0.601246 0.751892,0.926509 0.244364,0.325264 0.516924,0.640672 0.742492,0.956079 0.310156,0.423829 0.629709,0.867371 0.921067,1.330626 0.131582,0.216842 0.291358,0.443541 0.413541,0.660383 0.375945,0.581533 0.695499,1.182779 1.005655,1.784024 0.131581,0.275981 0.263162,0.581533 0.375945,0.877227 0.347751,0.808232 0.620311,1.62632 0.789486,2.454264 0.05639,0.177417 0.09399,0.36469 0.112785,0.542107 v 0.03942 c 0.05639,0.236556 0.07519,0.492825 0.09399,0.758949 0.07518,0.837802 0.0376,1.685459 -0.131582,2.533116 -0.07518,0.354834 -0.169174,0.689955 -0.281959,1.054644 -0.122182,0.344977 -0.234965,0.69981 -0.385344,1.044787 -0.291358,0.69981 -0.62971,1.409478 -1.033851,2.060005 -0.131581,0.246412 -0.291358,0.50268 -0.441736,0.749093 -0.169175,0.256268 -0.34775,0.50268 -0.498128,0.739236 -0.216169,0.305551 -0.441737,0.620958 -0.676702,0.906796 -0.206771,0.295694 -0.413541,0.591389 -0.648507,0.857515 -0.319554,0.404116 -0.62971,0.778661 -0.958662,1.143351 -0.187972,0.236556 -0.394743,0.482967 -0.610911,0.699811 -0.206771,0.246411 -0.42294,0.463254 -0.610913,0.660384 -0.328952,0.344976 -0.592115,0.601245 -0.817682,0.827944 l -0.535722,0.502681 c -0.07518,0.07886 -0.178575,0.118277 -0.28196,0.118277 h -4.116606 v 5.529487 h 5.178653 c 1.156033,0 2.255675,-0.423828 3.148546,-1.222204 0.300757,-0.275981 1.625965,-1.478471 3.195539,-3.292065 0.05639,-0.06899 0.122183,-0.10842 0.197372,-0.128134 l 14.295338,-4.336852 c 0.272561,-0.07885 0.535722,0.128134 0.535722,0.423828 z"
              fill="#222222"
              id="opensea-2"
              style="fill: #f9f9f9; stroke-width: 1.06942"
            />
          </g>
        </svg>

        <h5 v-if="!(mq.xs || mq.sm)">OpeanSea</h5>
      </a>
      <a class="sidebar-link" href="https://rarible.com/blackcatartist">
        <svg
          :class="`${mq.xs || mq.sm ? 'mobile' : 'full'}`"
          class="full"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 72 72"
        >
          <path id="rarible-1" fill="#feda03" d="M0 0h72v72H0z" />
          <path
            id="rarible-2"
            d="M49.32 35.91c2.27-.59 4.29-2.28 4.29-5.7 0-5.67-4.82-7-11-7H18V48.8h10.36V40.1h12.28c1.9 0 3 .75 3 2.6v6.08H54v-6.4c0-3.48-1.96-5.68-4.68-6.48zm-8.5-2.7H28.36v-2.5h12.46c1.36 0 2.18.18 2.18 1.25 0 1.08-.82 1.25-2.18 1.25z"
          />
        </svg>
        <h5 v-if="!(mq.xs || mq.sm)">Rarible</h5>
      </a>
      <a class="sidebar-link" href="https://www.instagram.com/black.cat.nft/">
        <svg
          :class="`${mq.xs || mq.sm ? 'mobile' : 'full'}`"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <radialGradient
              cx="-578.95"
              cy="-837.6"
              gradientTransform="translate(499.5 629.5) scale(0.75)"
              gradientUnits="userSpaceOnUse"
              id="radial-gradient"
              r="197.06"
            >
              <stop offset="0" stop-color="#f9ed32" />
              <stop offset="0.36" stop-color="#ee2a7b" />
              <stop offset="0.44" stop-color="#d22a8a" />
              <stop offset="0.6" stop-color="#8b2ab2" />
              <stop offset="0.83" stop-color="#1b2af0" />
              <stop offset="0.88" stop-color="#002aff" />
            </radialGradient>
          </defs>
          <g data-name="3-instagram" id="_3-instagram">
            <rect
              height="64"
              rx="11.2"
              ry="11.2"
              transform="translate(64 64) rotate(180)"
              width="64"
              fill="url('#radial-gradient')"
            />
            <path
              class="icon cls-2"
              d="M44,56H20A12,12,0,0,1,8,44V20A12,12,0,0,1,20,8H44A12,12,0,0,1,56,20V44A12,12,0,0,1,44,56ZM20,12.8A7.21,7.21,0,0,0,12.8,20V44A7.21,7.21,0,0,0,20,51.2H44A7.21,7.21,0,0,0,51.2,44V20A7.21,7.21,0,0,0,44,12.8Z"
            />
            <path
              class="icon cls-2"
              d="M32,45.6A13.6,13.6,0,1,1,45.6,32,13.61,13.61,0,0,1,32,45.6Zm0-22.4A8.8,8.8,0,1,0,40.8,32,8.81,8.81,0,0,0,32,23.2Z"
            />
            <circle class="icon cls-2" cx="45.6" cy="19.2" r="2.4" />
          </g>
        </svg>
        <h5 v-if="!(mq.xs || mq.sm)">Instagram</h5>
      </a>
      <a class="sidebar-link" href="https://rarible.com/blackcatartist">
        <svg
          :class="`${mq.xs || mq.sm ? 'mobile' : 'full'}`"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title />
          <g data-name="6-twitter" id="_6-twitter">
            <rect
              class="icon cls-3"
              height="64"
              rx="11.2"
              ry="11.2"
              transform="translate(64 64) rotate(180)"
              width="64"
            />
            <path
              class="icon cls-2"
              d="M47.2,20.8a8,8,0,0,0,4-4.8c-1.6,1.6-5,2.13-5,2.13A8,8,0,0,0,32.37,25.6H32a23.45,23.45,0,0,1-16.8-8.8S10.4,23.2,17.6,28c0,0-3.2,0-4-.8,0,0-.8,4.8,6.4,8a3.86,3.86,0,0,1-3.2,0c0,3.09,3.22,5.6,7.2,5.6,0,2.21-5.37,4-12,4C22.4,52,47.2,50.4,48.8,23.2l4-4Z"
            />
          </g>
        </svg>
        <h5 v-if="!(mq.xs || mq.sm)">Twitter</h5>
      </a>
    </section>
  </o-sidebar>
</template>

<script>
import { onMounted, ref } from "vue";
import { useMq } from "vue3-mq";

export default {
  setup() {
    const expandOnHover = false;
    const mobile = "reduced";
    const reduce = ref(false);
    const mq = useMq();

    onMounted(() => {
      console.log(reduce.value);
    });

    return {
      expandOnHover,
      mobile,
      reduce,
      mq,
    };
  },
};
</script>

<style lang="scss">
.sidebar-layout {
  display: flex;
  flex-direction: row;
  min-height: 100%;
}

.o-side__content.sidebar-layout-content {
  width: 100%;
  max-width: 24rem;
  background-color: #222;
  color: aliceblue;
  a {
    color: #fff;
  }
}

.sidebar-link {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background-color: rgba(241, 194, 36, 0.87);
    box-shadow: 0px 0px 0px 2px rgba(161, 97, 1, 0.788);
    transform-origin: bottom right;
    transform: scaleX(0);
    transition: transform 0.5s ease;
    width: calc(60% + 4vw);
  }

  &:hover::before {
    transform-origin: bottom left;
    transform: scaleX(1);
  }

  display: block;
  padding: 0.5rem;

  h5 {
    font-size: 1.2rem;
    margin-bottom: 0.8rem;
    display: inline-block;
  }

  svg.full {
    width: 1.4rem;
    height: 1.4rem;
    display: inline-block;
    margin-right: 0.8rem;
    margin-top: -0.4rem;
  }

  svg.mobile {
    width: 2.7rem;
    height: 2.7rem;
    display: block;
    margin: 0 auto;
    padding: 0.2rem 0 0.2rem 0;
  }
}

.icon.cls-2 {
  fill: #fff;
}

.icon.cls-3 {
  fill: #00aade;
}

.homebtnContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

a.homebtn {
  position: relative;
  display: inline-block;
  padding: 2rem 1rem;
  margin: 4rem 0;
  color: #03e9f4;
  text-decoration: none;
  text-transform: uppercase;
  transition: 0.5s;
  letter-spacing: 4px;
  overflow: hidden;
  //margin-right: 50px;
  font-weight: bold;
  font-size: calc(5px + 0.7vw);
}

a.homebtn {
  .h1-mobile {
    font-size: 0.8rem;
  }
}

a.homebtn:hover {
  background: #03e9f4;
  color: #050801;
  box-shadow: 0 0 1rem #03e9f4, 0 0 2rem #03e9f4, 0 0 5rem #03e9f4,
    0 0 20rem #03e9f4;
  -webkit-box-reflect: below 0.5rem linear-gradient(transparent, #0005);
}

a.homebtn span {
  position: absolute;
  display: block;
}
a.homebtn span:nth-child(1) {
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #03e9f4);
  animation: animate1 2s linear infinite;
}
@keyframes animate1 {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 100%;
  }
}
a.homebtn span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #03e9f4);
  animation: animate2 2s linear infinite;
  animation-delay: 0.25s;
}
@keyframes animate2 {
  0% {
    top: -100%;
  }
  50%,
  100% {
    top: 100%;
  }
}
a.homebtn span:nth-child(3) {
  bottom: 0;
  right: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, transparent, #03e9f4);
  animation: animate3 2s linear infinite;
  animation-delay: 0.5s;
}
@keyframes animate3 {
  0% {
    right: -100%;
  }
  50%,
  100% {
    right: 100%;
  }
}

a.homebtn span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #03e9f4);
  animation: animate4 2s linear infinite;
  animation-delay: 0.75s;
}
@keyframes animate4 {
  0% {
    bottom: -100%;
  }
  50%,
  100% {
    bottom: 100%;
  }
}
</style>
